module.exports = [
	{
		"group": "head",
		"modifiers": [
			{
				"target": "head-age",
				"min": "less",
				"max": "more"
			},
			{
				"target": "head-angle",
				"min": "in",
				"max": "out"
			},
			{
				"target": "head",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "head-oval"
			},
			{
				"target": "head-round"
			},
			{
				"target": "head-rectangular"
			},
			{
				"target": "head-square"
			},
			{
				"target": "head-triangular"
			},
			{
				"target": "head-invertedtriangular"
			},
			{
				"target": "head-diamond"
			},
			{
				"target": "head-scale-depth",
				"min": "less",
				"max": "more"
			},
			{
				"target": "head-scale-horiz",
				"min": "less",
				"max": "more"
			},
			{
				"target": "head-scale-vert",
				"min": "less",
				"max": "more"
			},
			{
				"target": "head-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "head-trans",
				"min": "down",
				"max": "up"
			},
			{
				"target": "head-trans",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "head-back-scale-depth",
				"min": "less",
				"max": "more"
			}
		]
	},
	{
		"group": "forehead",
		"modifiers": [
			{
				"target": "forehead-trans-depth",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "forehead-scale-vert",
				"min": "less",
				"max": "more"
			},
			{
				"target": "forehead-nubian",
				"min": "less",
				"max": "more"
			},
			{
				"target": "forehead-temple",
				"min": "in",
				"max": "out"
			}
		]
	},
	{
		"group": "eyebrows",
		"modifiers": [
			{
				"target": "eyebrows-trans-depth",
				"min": "less",
				"max": "more"
			},
			{
				"target": "eyebrows-angle",
				"min": "up",
				"max": "down"
			},
			{
				"target": "eyebrows-trans-vert",
				"min": "less",
				"max": "more"
			}
		]
	},
	{
		"group": "neck",
		"modifiers": [
			{
				"target": "neck-double",
				"min": "less",
				"max": "more"
			},
			{
				"target": "neck-scale-depth",
				"min": "less",
				"max": "more"
			},
			{
				"target": "neck-scale-horiz",
				"min": "less",
				"max": "more"
			},
			{
				"target": "neck-scale-vert",
				"min": "less",
				"max": "more"
			},
			{
				"target": "neck-trans-horiz",
				"min": "in",
				"max": "out"
			},
			{
				"target": "neck-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "neck-trans-depth",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "neck-back-scale-depth",
				"min": "less",
				"max": "more"
			}
		]
	},
	{
		"group": "eyes",
		"modifiers": [
			{
				"target": "r-eye-bag",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-eye-bag",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-eye-bag-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-eye-eyefold-angle",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-eye-epicanthus",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-eye-eyefold",
				"min": "concave",
				"max": "convex"
			},
			{
				"target": "r-eye-eyefold",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-eye-height1",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-eye-height2",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-eye-height3",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-eye-push1",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-eye-push2",
				"min": "out",
				"max": "in"
			},
			{
				"target": "r-eye-move",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-eye-move",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-eye-size",
				"min": "small",
				"max": "big"
			},
			{
				"target": "r-eye-corner1",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-eye-corner2",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-eye-bag",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-eye-bag",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-eye-bag-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-eye-eyefold-angle",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-eye-epicanthus",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-eye-eyefold",
				"min": "concave",
				"max": "convex"
			},
			{
				"target": "l-eye-eyefold",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-eye-height1",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-eye-height2",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-eye-height3",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-eye-push1",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-eye-push2",
				"min": "out",
				"max": "in"
			},
			{
				"target": "l-eye-move",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-eye-move",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-eye-size",
				"min": "small",
				"max": "big"
			},
			{
				"target": "l-eye-corner1",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-eye-corner2",
				"min": "down",
				"max": "up"
			}
		]
	},
	{
		"group": "nose",
		"modifiers": [
			{
				"target": "nose-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "nose-trans-depth",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "nose-trans-horiz",
				"min": "in",
				"max": "out"
			},
			{
				"target": "nose-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "nose-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "nose-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "nose-nostril-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nose-point-width",
				"min": "less",
				"max": "more"
			},
			{
				"target": "nose-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nose-width1",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nose-width2",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nose-width3",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nose-compression",
				"min": "compress",
				"max": "uncompress"
			},
			{
				"target": "nose-curve",
				"min": "concave",
				"max": "convex"
			},
			{
				"target": "nose-greek",
				"min": "lessgreek",
				"max": "moregreek"
			},
			{
				"target": "nose-hump",
				"min": "lesshump",
				"max": "morehump"
			},
			{
				"target": "nose-volume",
				"min": "potato",
				"max": "point"
			},
			{
				"target": "nose-nostrils-angle",
				"min": "down",
				"max": "up"
			},
			{
				"target": "nose-point",
				"min": "down",
				"max": "up"
			},
			{
				"target": "nose-septumangle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "nose-flaring",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "mouth",
		"modifiers": [
			{
				"target": "mouth-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "mouth-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "mouth-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "mouth-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "mouth-trans",
				"min": "down",
				"max": "up"
			},
			{
				"target": "mouth-trans",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "mouth-lowerlip-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "mouth-lowerlip-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "mouth-upperlip-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "mouth-upperlip-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "mouth-cupidsbow-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "mouth-dimples",
				"min": "in",
				"max": "out"
			},
			{
				"target": "mouth-laugh-lines",
				"min": "in",
				"max": "out"
			},
			{
				"target": "mouth-lowerlip-ext",
				"min": "up",
				"max": "down"
			},
			{
				"target": "mouth-angles",
				"min": "down",
				"max": "up"
			},
			{
				"target": "mouth-lowerlip-middle",
				"min": "up",
				"max": "down"
			},
			{
				"target": "mouth-lowerlip-volume",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "mouth-philtrum-volume",
				"min": "increase",
				"max": "decrease"
			},
			{
				"target": "mouth-upperlip-volume",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "mouth-upperlip-ext",
				"min": "down",
				"max": "up"
			},
			{
				"target": "mouth-upperlip-middle",
				"min": "down",
				"max": "up"
			},
			{
				"target": "mouth-cupidsbow",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "ears",
		"modifiers": [
			{
				"target": "r-ear-trans-depth",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "r-ear-size",
				"min": "small",
				"max": "big"
			},
			{
				"target": "r-ear-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-ear-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-ear-lobe",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-ear-shape1",
				"min": "pointed",
				"max": "triangle"
			},
			{
				"target": "r-ear-rot",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "r-ear-shape2",
				"min": "square",
				"max": "round"
			},
			{
				"target": "r-ear-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "r-ear-wing",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-ear-flap",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-ear-trans-depth",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "l-ear-size",
				"min": "small",
				"max": "big"
			},
			{
				"target": "l-ear-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "l-ear-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-ear-lobe",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-ear-shape1",
				"min": "pointed",
				"max": "triangle"
			},
			{
				"target": "l-ear-rot",
				"min": "backward",
				"max": "forward"
			},
			{
				"target": "l-ear-shape2",
				"min": "square",
				"max": "round"
			},
			{
				"target": "l-ear-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "l-ear-wing",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-ear-flap",
				"min": "in",
				"max": "out"
			}
		]
	},
	{
		"group": "chin",
		"modifiers": [
			{
				"target": "chin-jaw-drop",
				"min": "less",
				"max": "more"
			},
			{
				"target": "chin-cleft",
				"min": "in",
				"max": "out"
			},
			{
				"target": "chin-prominent",
				"min": "less",
				"max": "more"
			},
			{
				"target": "chin-width",
				"min": "min",
				"max": "max"
			},
			{
				"target": "chin-height",
				"min": "min",
				"max": "max"
			},
			{
				"target": "chin-bones",
				"min": "in",
				"max": "out"
			},
			{
				"target": "chin-prognathism",
				"min": "less",
				"max": "more"
			}
		]
	},
	{
		"group": "cheek",
		"modifiers": [
			{
				"target": "l-cheek-volume",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "l-cheek-bones",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-cheek-inner",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "l-cheek-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "r-cheek-volume",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "r-cheek-bones",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-cheek-inner",
				"min": "deflate",
				"max": "inflate"
			},
			{
				"target": "r-cheek-trans-vert",
				"min": "down",
				"max": "up"
			}
		]
	},
	{
		"group": "torso",
		"modifiers": [
			{
				"target": "torso-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "torso-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "torso-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "torso-trans-horiz",
				"min": "in",
				"max": "out"
			},
			{
				"target": "torso-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "torso-trans-depth",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "torso-vshape",
				"min": "less",
				"max": "more"
			},
			{
				"target": "torso-muscle-dorsi",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "torso-muscle-pectoral",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "hip",
		"modifiers": [
			{
				"target": "hip-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "hip-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "hip-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "hip-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "hip-trans",
				"min": "down",
				"max": "up"
			},
			{
				"target": "hip-trans",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "hip-waist",
				"min": "down",
				"max": "up"
			}
		]
	},
	{
		"group": "stomach",
		"modifiers": [
			{
				"target": "stomach-navel",
				"min": "in",
				"max": "out"
			},
			{
				"target": "stomach-tone",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "stomach-pregnant",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "stomach-navel",
				"min": "down",
				"max": "up"
			}
		]
	},
	{
		"group": "buttocks",
		"modifiers": [
			{
				"target": "buttocks-volume",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "pelvis",
		"modifiers": [
			{
				"target": "pelvis-tone",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "bulge",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "armslegs",
		"modifiers": [
			{
				"target": "r-hand-fingers-distance",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-hand-fingers-diameter",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-hand-fingers-length",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-hand-scale",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-hand-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-hand-fingers-distance",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-hand-fingers-diameter",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-hand-fingers-length",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-hand-scale",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-hand-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-foot-scale",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-foot-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "r-foot-trans",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "l-foot-scale",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-foot-trans",
				"min": "in",
				"max": "out"
			},
			{
				"target": "l-foot-trans",
				"min": "forward",
				"max": "backward"
			},
			{
				"target": "r-lowerarm-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-lowerarm-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-lowerarm-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-lowerarm",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "r-lowerarm-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperarm-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperarm-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperarm-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperarm",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "r-upperarm-shoulder-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperarm-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerarm-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerarm-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerarm-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerarm",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "l-lowerarm-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperarm-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperarm-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperarm-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperarm",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "l-upperarm-shoulder-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperarm-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-leg-genu",
				"min": "varun",
				"max": "valgus"
			},
			{
				"target": "r-lowerleg-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-lowerleg-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-lowerleg",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "r-lowerleg-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperleg-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperleg-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperleg-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "r-upperleg",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "r-upperleg-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-leg-genu",
				"min": "varun",
				"max": "valgus"
			},
			{
				"target": "l-lowerleg-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerleg-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-lowerleg",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "l-lowerleg-muscle",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperleg-scale-depth",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperleg-scale-horiz",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperleg-scale-vert",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "l-upperleg",
				"min": "skinny",
				"max": "fat"
			},
			{
				"target": "l-upperleg-muscle",
				"min": "decr",
				"max": "incr"
			}
		]
	},
	{
		"group": "breast",
		"modifiers": [
			{
				"macrovar": "BreastSize"
			},
			{
				"macrovar": "BreastFirmness"
			},
			{
				"target": "breast-trans-vert",
				"min": "down",
				"max": "up"
			},
			{
				"target": "breast-dist",
				"min": "min",
				"max": "max"
			},
			{
				"target": "breast-point",
				"min": "min",
				"max": "max"
			},
			{
				"target": "breast-volume-vert",
				"min": "up",
				"max": "down"
			},
			{
				"target": "nipple-size",
				"min": "min",
				"max": "max"
			},
			{
				"target": "nipple-point",
				"min": "in",
				"max": "out"
			}
		]
	},
	{
		"group": "genitals",
		"modifiers": [
			{
				"target": "penis-length",
				"min": "min",
				"max": "max"
			},
			{
				"target": "penis-circ",
				"min": "min",
				"max": "max"
			},
			{
				"target": "penis-testicles",
				"min": "min",
				"max": "max"
			}
		]
	},
	{
		"group": "macrodetails",
		"modifiers": [
			{
				"macrovar": "Gender"
			},
			{
				"macrovar": "Age"
			},
			{
				"macrovar": "African",
				"modifierType": "EthnicModifier"
			},
			{
				"macrovar": "Asian",
				"modifierType": "EthnicModifier"
			},
			{
				"macrovar": "Caucasian",
				"modifierType": "EthnicModifier"
			}
		]
	},
	{
		"group": "macrodetails-universal",
		"modifiers": [
			{
				"macrovar": "Muscle"
			},
			{
				"macrovar": "Weight"
			}
		]
	},
	{
		"group": "macrodetails-height",
		"modifiers": [
			{
				"macrovar": "Height"
			}
		]
	},
	{
		"group": "macrodetails-proportions",
		"modifiers": [
			{
				"macrovar": "BodyProportions"
			}
		]
	},
	{
		"group": "legs",
		"modifiers": [
			{
				"target": "legs-upperlegheight",
				"min": "decr",
				"max": "incr"
			},
			{
				"target": "legs-lowerlegheight",
				"min": "decr",
				"max": "incr"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/makehuman-data/src/json/modifiers/modeling_modifiers.json
// module id = 148
// module chunks = 0